// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  color: #ffffff;
  border: none;
}

.product {
  margin: 0 auto;
}
.product img {
  width: 100%;
}
.product-item {
  margin-top: 30px;
  padding: 10px;
  background-color: #f8f8f8;
  min-height: auto;
}
@media screen and (min-width: 767px) {
  /* .product-item {
    min-height: 655px;
  } */
}
.product-item img {
  border-radius: 8px;
}
.product-item-txt {
  padding: 10px 16px 16px 16px;
}
.product-item-txt p {
  font-weight: 500;
  text-align: left;
  color: #000000;
}
.product-item-txt p.small {
  color: #000000;
}
.product-types {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 30px;
  flex-wrap: wrap;
}
@media screen and (min-width: 797px) {
  .product-types {
    flex-wrap: nowrap;
    padding-top: 90px;
  }
}
.product-types img {
  max-width: 120px;
  transition: transform 0.3s ease-in-out;
}
.product-types img:hover {
  transform: scale(1.08);
}
.product-types p {
  text-align: center;
  margin: 0 auto;
  padding: 0;
} `, "",{"version":3,"sources":["webpack://./src/components/Product/product.scss","webpack://./src/components/Product/product.css"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,UAAA;EAEA,cAAA;EACA,YAAA;ACAF;;ADGA;EACE,cAAA;ACAF;ADEE;EACE,WAAA;ACAJ;ADGE;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;ACDJ;ADEI;EALF;;KCOA;AACF;ADCI;EACE,kBAAA;ACCN;ADEI;EACE,4BAAA;ACAN;ADEM;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;ACAR;ADEQ;EACE,cAAA;ACAV;ADME;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,eAAA;ACJJ;ADKI;EANF;IAOI,iBAAA;IACA,iBAAA;ECFJ;AACF;ADII;EACE,gBAAA;EACA,sCAAA;ACFN;ADGM;EACE,sBAAA;ACDR;ADKI;EACE,kBAAA;EACA,cAAA;EACA,UAAA;ACHN","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n\n  color: #ffffff;\n  border: none;\n}\n\n.product {\n  margin: 0 auto;\n\n  img {\n    width: 100%;\n  }\n\n  &-item {\n    margin-top: 30px;\n    padding: 10px;\n    background-color: #f8f8f8;\n    min-height: auto;\n    @media screen and (min-width: 767px) {\n      min-height: 655px;\n    }\n\n    img {\n      border-radius: 8px;\n    }\n\n    &-txt {\n      padding: 10px 16px 16px 16px;\n\n      p {\n        font-weight: 500;\n        text-align: left;\n        color: #000000;\n\n        &.small {\n          color: #000000;\n        }\n      }\n    }\n  }\n\n  &-types {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-top: 30px;\n    flex-wrap: wrap;\n    @media screen and (min-width: 797px) {\n      flex-wrap: nowrap;\n      padding-top: 90px;\n    }\n\n    img {\n      max-width: 120px;\n      transition: transform 0.3s ease-in-out;\n      &:hover {\n        transform: scale(1.08);\n      }\n    }\n\n    p {\n      text-align: center;\n      margin: 0 auto;\n      padding: 0;\n    }\n  }\n}\n","* {\n  margin: 0;\n  padding: 0;\n  color: #ffffff;\n  border: none;\n}\n\n.product {\n  margin: 0 auto;\n}\n.product img {\n  width: 100%;\n}\n.product-item {\n  margin-top: 30px;\n  padding: 10px;\n  background-color: #f8f8f8;\n  min-height: auto;\n}\n@media screen and (min-width: 767px) {\n  /* .product-item {\n    min-height: 655px;\n  } */\n}\n.product-item img {\n  border-radius: 8px;\n}\n.product-item-txt {\n  padding: 10px 16px 16px 16px;\n}\n.product-item-txt p {\n  font-weight: 500;\n  text-align: left;\n  color: #000000;\n}\n.product-item-txt p.small {\n  color: #000000;\n}\n.product-types {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 30px;\n  flex-wrap: wrap;\n}\n@media screen and (min-width: 797px) {\n  .product-types {\n    flex-wrap: nowrap;\n    padding-top: 90px;\n  }\n}\n.product-types img {\n  max-width: 120px;\n  transition: transform 0.3s ease-in-out;\n}\n.product-types img:hover {\n  transform: scale(1.08);\n}\n.product-types p {\n  text-align: center;\n  margin: 0 auto;\n  padding: 0;\n} /*# sourceMappingURL=product.css.map */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
